import React, { memo } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Icon } from 'components';
import { Button, Text } from '@beef/ui-kit';

// Styles
import styles from '../../styles.pcss';
const cn = classNames.bind(styles);

export const BackArrow = memo(({ arrowText, onBack = () => {} }) => (
  <div className={cn('error__arrow')}>
    <Button icon={<Icon name="arrow" />} variant="plain" onClick={onBack}>
      <div className={cn('error__arrow-text')}>
        <Text color="grey50" size="size5-m">{arrowText}</Text>
      </div>
    </Button>
  </div>
));

BackArrow.propTypes = {
  onBack: PropTypes.func,
  arrowText: PropTypes.string,
};
